import React from 'react';

export const SearchIcon = props =>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15.344"
    height="16.344"
    viewBox="0 0 15.344 16.344"
    style={{
      fillRule: 'evenodd',
    }}
    {...props}
  >
    <path
      d="M842.936,383.229l4.392,4.392-0.707.707-4.46-4.46A6.708,6.708,0,1,1,842.936,383.229ZM838.5,373a5.5,5.5,0,1,0,5.5,5.5A5.5,5.5,0,0,0,838.5,373Z"
      transform="translate(-832 -372)"
    />
  </svg>;



// WEBPACK FOOTER //
// ./app/components/icons/search-icon.js